import { createAction, props } from '@ngrx/store';
import { EstreamPanel } from 'brain-data/model/estream-panel.model';

export const loadEstreamPanels = createAction('[EstreamPanels] load');
export const loadEstreamPanelsSuccess = createAction(
  '[EstreamPanels] load success',
  props<{ panels: EstreamPanel[] }>(),
);
export const loadEstreamPanelsError = createAction(
  '[EstreamPanels] load error',
  props<{ error: Error }>(),
);
